import { Box, HStack, VStack } from '@chakra-ui/react';

import GradientTooltip from './GradientTooltip';
import Text from './Text';

const TokenCostCard = ({ cost, items }: { cost: string; items: string[] }) => (
  <Box
    width="100%"
    p={2}
    borderRadius="md"
    border="1px solid"
    borderColor="whiteAlpha.200"
    backgroundColor="whiteAlpha.50"
  >
    <HStack spacing={1.5} mb={1}>
      <Box
        px={1.5}
        py={0.5}
        borderRadius="sm"
        bgGradient="linear(to-r, rgba(249,115,22,0.2), rgba(239,68,68,0.15))"
      >
        <Text style={{ fontSize: '10px', lineHeight: 1 }} fontWeight="bold" color="orange.300">
          {cost}
        </Text>
      </Box>
      <Text style={{ fontSize: '10px', lineHeight: 1 }} opacity="tertiary">
        BigToken{cost !== '1' ? 's' : ''}
      </Text>
    </HStack>
    <VStack spacing={0.5} align="start" pl={0.5}>
      {items.map((item) => (
        <Text key={item} style={{ fontSize: '10px', lineHeight: '14px' }} opacity="secondary">
          &bull; {item}
        </Text>
      ))}
    </VStack>
  </Box>
);

const BigTokenTooltipLabel = () => (
  <VStack spacing={1.5} align="start">
    <Text fontSize="micro" fontWeight="semibold">
      BigToken costs:
    </Text>
    <TokenCostCard cost="1" items={['Prototype', '50K AI tokens', '5 MB storage', 'AI CV review']} />
    <TokenCostCard cost="3" items={['Generate CV', 'Import CV', 'Roast']} />
  </VStack>
);

const BigTokenTooltip = () => (
  <GradientTooltip label={<BigTokenTooltipLabel />} placement="bottom">
    <Box
      as="span"
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      w="16px"
      h="16px"
      borderRadius="full"
      bg="whiteAlpha.100"
      borderWidth={1}
      borderColor="whiteAlpha.200"
      cursor="help"
      _hover={{ bg: 'whiteAlpha.200', borderColor: 'whiteAlpha.300' }}
      transition="all 0.15s"
      ml={1}
    >
      <Text style={{ fontSize: '10px', lineHeight: 1 }} opacity="secondary">
        ?
      </Text>
    </Box>
  </GradientTooltip>
);

export default BigTokenTooltip;
